import planContainerTypes from 'Enums/planContainerTypes'
import { SubscriptionPeriod } from 'Types'

export class AppPlan {
  id: number
  period: SubscriptionPeriod
  container: number
  name: string
  
  monthlyPrice: number
  price: number
  priceTotal: number

  priority: string | boolean
  discount: string | boolean
  bonus: string | boolean
  category: string
  city: string
  position: string
  support: boolean

  constructor(name) {
    this.id = null
    this.name = name
    this.price = null
    this.priority = false
    this.discount = false
    this.bonus = false
    this.category = null
    this.city = null
    this.position = null
    this.support = false
    this.priceTotal = null
  }

  withID(id) {
    this.id = id

    return this
  }

  withContainer(container) {
    this.container = container

    return this
  }

  withMonthlyPrice(monthlyPrice) {
    this.monthlyPrice = monthlyPrice
    
    return this
  }

  withPrice(price) {
    this.price = price

    return this
  }

  withPriceTotal(priceTotal) {
    this.priceTotal = priceTotal

    return this
  }


  withPeriod(period: SubscriptionPeriod) {
    this.period = period

    return this
  }

  withPriority(priority) {
    this.priority = priority

    return this
  }

  withDiscount(discount) {
    this.discount = discount

    return this
  }

  withBonus(bonus) {
    this.bonus = bonus

    return this
  }

  withCategory(category) {
    this.category = category

    return this
  }

  withCity(city) {
    this.city = city

    return this
  }

  withPosition(position) {
    this.position = position

    return this
  }

  withSupport() {
    this.support = true

    return this
  }
}

export const demandPlan = new AppPlan('Sob demanda')
  .withID(30)
  .withContainer(planContainerTypes.demand)
  .withPriority('regular')
  .withPosition('Abaixo de todos')

export const basicPlan = new AppPlan('Básico')
  .withContainer(planContainerTypes.basic)
  .withPriority('média')
  .withDiscount(`<b>5%</b> `)
  .withBonus(`<b>99 créditos/mês</b> para compra de pedidos`)
  .withPosition('acima do demanda')

export const mediumPlan = new AppPlan('Padrão')
  .withContainer(planContainerTypes.medium)
  .withPriority('alta')
  .withDiscount(`<b>5%</b> `)
  .withBonus(`<b>99 créditos/mês</b> de bônus mensal`)
  .withPosition('acima do demanda')

export const advancedPlan = new AppPlan('Avançado')
  .withContainer(planContainerTypes.advanced)
  .withPriority('muito alta')
  .withDiscount(`<b>10%</b> `)
  .withBonus(`<b>199 créditos/mês</b> para compra de pedidos`)
  .withPosition('acima do padrão')

export const elitePlan = new AppPlan('Elite')
  .withID(26)
  .withContainer(planContainerTypes.elite)
  .withPriority('super alta')
  .withDiscount(`<b>15%</b>`)
  .withBonus('Bônus mensal flexível')
  .withPosition('acima do avançado')
  .withSupport()

export const diamondPlan = new AppPlan('Diamante')
  .withID(25)
  .withContainer(planContainerTypes.diamond)
  .withPriority('máxima')
  .withDiscount(`<b>100%</b>`)
  .withBonus('Bônus mensal ilimitado')
  .withPosition('acima do elite')
  .withSupport()

export default [
  demandPlan,
  basicPlan,
  mediumPlan,
  advancedPlan,
  elitePlan,
  diamondPlan
]
